export default __webpack_public_path__ + "static/mark sikorski-ebf543b45ed881ca3d293bcbc77f84d8.webp";